(() => {
  'use strict';
  // Keep Shopify's customer form and spam protection; enhance only its response.
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('.af-access-form') || event.defaultPrevented) return;
    if (form.dataset.nativeSignup === 'true') return;
    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-af-signup-status]');
    const label = button.querySelector('span');
    const originalLabel = label.textContent;
    const formHeight = form.getBoundingClientRect().height;
    const payload = new URLSearchParams(new FormData(form));
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    label.textContent = 'Joining…';
    status.hidden = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(form.action, {
        method: 'POST', body: payload, credentials: 'same-origin',
        headers: { Accept: 'text/html' }, signal: controller.signal
      });
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const returnedForm = page.getElementById(form.id);
      const success = returnedForm?.querySelector('[data-af-signup-success]');
      const error = returnedForm?.querySelector('[data-af-signup-error]');
      if (response.ok && success) {
        // Prevent the shorter confirmation from moving a visitor near the page bottom.
        form.style.minHeight = `${formHeight}px`;
        form.replaceChildren(document.importNode(success, true));
        form.querySelector('[data-af-form-result]')?.focus({ preventScroll: true });
      } else if (error) {
        status.textContent = error.textContent.trim();
        status.hidden = false;
        const input = form.querySelector('input[type="email"]');
        input.setAttribute('aria-invalid', 'true');
        input.addEventListener('input', () => input.removeAttribute('aria-invalid'), { once: true });
      } else {
        // Challenges and unexpected responses must never look like a successful signup.
        // Let the visitor continue through Shopify's native form on their next click.
        form.dataset.nativeSignup = 'true';
        status.textContent = 'Please continue to finish signing up with Shopify.';
        status.hidden = false;
        label.textContent = 'Continue';
      }
    } catch {
      status.textContent = 'We couldn’t confirm your signup. Please check your connection and try again.';
      status.hidden = false;
    } finally {
      clearTimeout(timeout);
      form.removeAttribute('aria-busy');
      button.disabled = false;
      if (form.dataset.nativeSignup !== 'true') label.textContent = originalLabel;
    }
  });
})();
